import { render, staticRenderFns } from "./ConferenceProductCard.vue?vue&type=template&id=6203cb1c&scoped=true&"
import script from "./ConferenceProductCard.vue?vue&type=script&lang=js&"
export * from "./ConferenceProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceProductCard.vue?vue&type=style&index=0&id=6203cb1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203cb1c",
  null
  
)

export default component.exports